import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import AddGiftButton from "./AddGiftButton";
import AmountCheckbox from "./AmountCheckbox";
import { formatUSD } from "./helpers";
import useEnsureCtfUpdates from "./useEnsureCtfUpdates";

export default function AmountDisplay({
  addOnGift,
  displayStatus,
  displayAmount,
  inputAmountUpdated,
  setInputAmountUpdated,
  setButtonHasBeenClicked,
  isChecked,
  setIsChecked,
  saveAmount,
}) {
  const {
    state: {
      fund: { fundColorSafe },
      amount,
      addOnAmounts,
    },
  } = usePaymentPage();
  const { isRequired, type, percentage } = addOnGift;
  const [haveSetRequiredAmount, setHaveSetRequiredAmount] = useState(false);

  useEnsureCtfUpdates({ addOnGift, isChecked });

  useEffect(() => {
    if (isRequired && !haveSetRequiredAmount) {
      setHaveSetRequiredAmount(true);
      saveAmount();
      setIsChecked(true);
    }
  }, [isRequired, saveAmount, haveSetRequiredAmount, setIsChecked]);

  const checkAndSaveAmount = () => {
    setIsChecked(true);
    saveAmount();
  };

  const handleButtonClick = () => {
    setButtonHasBeenClicked(true);
    checkAndSaveAmount();
  };

  const handleCheckboxToggle = (e) => {
    e.stopPropagation();
    saveAmount();
    setIsChecked((prev) => !prev);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
    if (!isChecked) setIsChecked(true);
    else return;
    saveAmount();
  };

  const handleInputChange = (value) => {
    let total = parseFloat(value || 0) + parseFloat(amount || 0);
    for (const a in addOnAmounts) total += parseFloat(a);
    if (total > 100000) return;
    saveAmount(value || 0, true);
    if (!inputAmountUpdated) setInputAmountUpdated(true);
  };

  const color = fundColorSafe;

  const displayPercentage =
    type === "percentage" && !amount
      ? `${Math.round(percentage * 100 * 100) / 100}%`
      : null;

  return (
    <>
      {displayStatus === "text-only" && (
        <AmountAsText $color={displayPercentage ? "#9a9a9a" : color}>
          {displayPercentage || formatUSD(displayAmount)}
        </AmountAsText>
      )}
      {displayStatus === "button" && (
        <AddGiftButton
          amount={displayAmount}
          addOnGift={addOnGift}
          onClick={handleButtonClick}
        />
      )}
      {displayStatus === "checkbox" && (
        <AmountCheckbox
          amount={displayAmount?.toString() || displayAmount}
          active={isChecked || isRequired}
          donationAmount={amount}
          disabled={isRequired}
          onToggle={handleCheckboxToggle}
          onInputClick={handleInputClick}
          onInputChange={handleInputChange}
          color={color}
          addOnGift={addOnGift}
        />
      )}
    </>
  );
}

AmountDisplay.propTypes = {
  addOnGift: PropTypes.object,
  displayStatus: PropTypes.string,
  displayAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputAmountUpdated: PropTypes.bool,
  setInputAmountUpdated: PropTypes.func,
  setButtonHasBeenClicked: PropTypes.func,
  isChecked: PropTypes.bool,
  setIsChecked: PropTypes.func,
  setHovering: PropTypes.func,
  saveAmount: PropTypes.func,
};

const AmountAsText = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  font-variant-numeric: tabular-nums;
  font-family: Montserrat;
  color: ${(p) => p.$color};
  margin-right: 16px;
  flex-grow: 1;
  text-align: right;
`;
